// extracted by mini-css-extract-plugin
module.exports = {"container":"toggle_container__VpAli"};